import { Component } from 'react';
import { connect } from 'react-redux';
import YourPersonalRewards from '../../home/personal-rewards/index';
import PrivacyPopup from '../../common/privacy-policy/privacy-popup';
import CookieConsent from '../../cookie-consent/cookie-consent';
import { isPseudoLoggedIn } from '../../../utils/tokenUtils';

class MainPopups extends Component {
  render() {
    let {
      showPersonalRewardsSettings, showPrivacyPopup, showSaveOrderDialog
    } = this.props.viewConfig;
    const pseudo = isPseudoLoggedIn();

    showPrivacyPopup = showPrivacyPopup && !pseudo;
    showPersonalRewardsSettings = showPersonalRewardsSettings && !showPrivacyPopup && !pseudo;
    showSaveOrderDialog = showSaveOrderDialog && !showPrivacyPopup;

    let activePopup = '';
    if (showPrivacyPopup) {
      activePopup = 'showPrivacyPopup';
    } else if (showPersonalRewardsSettings) {
      activePopup = 'showPersonalRewardsSettings';
    } else if (showSaveOrderDialog) {
      activePopup = 'showSaveOrderDialog';
    }
    return (
      <div>
        <CookieConsent/>
        {activePopup === 'showPrivacyPopup' && <PrivacyPopup show={showPrivacyPopup}/>}
        {activePopup === 'showPersonalRewardsSettings' && <YourPersonalRewards />}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  viewConfig: state.viewConfig,
  currentUser: state.currentUser.user,
  userLoading: state.currentUser.fetching,
});

export default connect(mapStateToProps)(MainPopups);
